import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
// import { getRecord } from './store/dataSlice'
import reducer from './store'
import { injectReducer } from 'store'
import InfoField from 'components/Ui/InfoField'
import { Modal, SimpleTable, Tabs } from 'components/Ui'
import { getApiBom, getApiDetails, getApiItem, getApiPack } from 'services/StockHoldingsService'
import { Button } from 'components/Form'
injectReducer('stockHoldings', reducer)

const View = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    // const dispatch = useDispatch()
    const [detailsData, setDetailsData] = useState([])
    const [bomData, setBomData] = useState([])
    const [packData, setPackData] = useState([])
    const [itemData, setItemData] = useState([])
    const [open, setOpen] = useState(false)
    const [openSOH, setOpenSOH] = useState(false)
    const [openUOM, setOpenUOM] = useState(false)
    const [openBOM, setOpenBOM] = useState(false)
    const [data, setData] = useState()

    const { loading } = useSelector(state => state.stockHoldings.data)

    useEffect(() => {
        if (id) {
            // fetchData(id)
            getApiDetails({ sku: id })
                .then(response => {
                    setDetailsData(response.data.data)
                })
                .catch(error => console.log('Error:', error))

            getApiBom({ sku: id })
                .then(response => {
                    setBomData(response.data.data)
                })
                .catch(error => console.log('Error:', error))

            getApiItem({ sku: id })
                .then(response => {
                    setItemData(response.data.data)
                })
                .catch(error => console.log('Error:', error))

            getApiPack({ pack_id: id })
                .then(response => {
                    setPackData(response.data.data)
                })
                .catch(error => console.log('Error:', error))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    // const fetchData = id => dispatch(getRecord(id))

    if (loading && id) {
        return null
    }

    return (
        <>
            <div className="flex flex-col gap-1 mb-3 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">Stock Holdings</h2>
            </div>
            <div className="flex flex-col items-center">
                <div className="w-full bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    {/* <Tabs.Group version={1}>
                        <div className="px-5 flex justify-between py-3 border-b border-stroke dark:border-strokedark">
                            <Tabs.List>
                                <Tabs>Header</Tabs>
                                <Tabs>Details</Tabs>
                            </Tabs.List>
                            <Button
                                className="h-10 w-18 text-white border bg-[red] border-primary dark:text-secondary dark:border-secondary"
                                onClick={() => navigate('/meson-wms/stock-holdings')}
                            >
                                Back
                            </Button>
                        </div>
                        <Tabs.Panels className="mt-4">
                            <Tabs.Panel>
                                <div className="flex flex-col gap-3 p-6">
                                    <div className="grid grid-cols-4 gap-4">
                                        <InfoField title="Warehouse: " value={record?.whse} />
                                        <div></div>
                                        <InfoField title="Product: " value={record?.Product} />
                                        <div></div>
                                        <InfoField title="Company: " value={record?.organization} />
                                        <div></div>
                                        <InfoField title="Customer: " value={record?.customer} />
                                        <div></div>
                                        <InfoField title="Total Allocated: " value={record?.Total_Allocated} />
                                        <div></div>
                                        <InfoField title="Total Available: " value={record?.Total_Available} />
                                        <div></div>
                                        <InfoField title="Total Held: " value={record?.Total_Held} />
                                        <div></div>
                                        <InfoField title="Total LPNs: " value={record?.Total_LPNs} />
                                        <div></div>
                                        <InfoField title="Total Locations: " value={record?.Total_Locations} />
                                        <div></div>
                                        <InfoField title="Total Quantity: " value={record?.total_qty} />
                                        <div></div>
                                        <InfoField title="Description: " value={record?.description} />
                                    </div>
                                </div>
                            </Tabs.Panel>
                            <Tabs.Panel>
                                <div className="grid grid-cols-1 gap-x-4 gap-y-4 overflow-y-auto min-h-70 max-h-70">
                                    <SimpleTable>
                                        <thead>
                                            <SimpleTable.TR>
                                                <SimpleTable.TH>Product Code</SimpleTable.TH>
                                                <SimpleTable.TH>Description</SimpleTable.TH>
                                                <SimpleTable.TH>Length (CM)</SimpleTable.TH>
                                                <SimpleTable.TH>Width (CM)</SimpleTable.TH>
                                                <SimpleTable.TH>Height (CM)</SimpleTable.TH>
                                                <SimpleTable.TH>Weight (Kg)</SimpleTable.TH>
                                                <SimpleTable.TH>Barcode 1</SimpleTable.TH>
                                                <SimpleTable.TH>Sku Group 1</SimpleTable.TH>
                                                <SimpleTable.TH>Lot Control</SimpleTable.TH>
                                                <SimpleTable.TH>Serical Control (Kg)</SimpleTable.TH>
                                                <SimpleTable.TH>Price</SimpleTable.TH>
                                                <SimpleTable.TH>Dangerous Goods</SimpleTable.TH>
                                            </SimpleTable.TR>
                                        </thead>
                                        <tbody>
                                            {(detailsData ?? []).map((item, index) => (
                                                <SimpleTable.TR
                                                    key={`details-${index}`}
                                                    onClick={() => {
                                                        setData(item)
                                                        setOpen(true)
                                                    }}
                                                >
                                                    <SimpleTable.TD>{item?.['Product Code']}</SimpleTable.TD>
                                                    <SimpleTable.TD className="text-left">{item?.['Description']}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.['Length (CM)']}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.['Width (CM)']}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.['Height (CM)']}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.['Weight (Kg)']}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.['Barcode 1']}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.['Sku Group 1']}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.['Lot Control']}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.['Serical Control']}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.['Price']}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.['Dangerous Goods']}</SimpleTable.TD>
                                                </SimpleTable.TR>
                                            ))}
                                        </tbody>
                                    </SimpleTable>
                                </div>
                            </Tabs.Panel>
                        </Tabs.Panels>
                    </Tabs.Group> */}

                    <div className="px-5 flex justify-between py-3 border-b border-stroke dark:border-strokedark">
                        <h5 className="font-bold">Details</h5>
                        <Button
                            className="h-10 w-18 text-white border bg-[red] border-primary dark:text-secondary dark:border-secondary"
                            onClick={() => navigate('/meson-wms/stock-holdings')}
                        >
                            Back
                        </Button>
                    </div>
                    <div className="flex flex-col gap-3 p-6">
                        <div className="grid grid-cols-4 gap-4">
                            <InfoField title="Product Code: " value={detailsData ? detailsData[0]?.['Product Code'] : ''} />
                            <div></div>
                            <InfoField title="Barcode 1: " value={detailsData ? detailsData[0]?.['Barcode 1'] : ''} />
                            <div></div>
                            <InfoField title="Length (CM): " value={detailsData ? detailsData[0]?.['Length (CM)'] : ''} />
                            <div></div>
                            <InfoField title="Barcode 2: " value={detailsData ? detailsData[0]?.['Barcode 2'] : ''} />
                            <div></div>
                            <InfoField title="Width (CM): " value={detailsData ? detailsData[0]?.['Width (CM)'] : ''} />
                            <div></div>
                            <InfoField title="Barcode 3: " value={detailsData ? detailsData[0]?.['Barcode 3'] : ''} />
                            <div></div>
                            <InfoField title="Height (CM): " value={detailsData ? detailsData[0]?.['Height (CM)'] : ''} />
                            <div></div>
                            <InfoField title="Sku Group 1: " value={detailsData ? detailsData[0]?.['Sku Group 1'] : ''} />
                            <div></div>
                            <InfoField title="Weight (Kg): " value={detailsData ? detailsData[0]?.['Weight (KG)'] : ''} />
                            <div></div>
                            <InfoField title="Sku Group 2: " value={detailsData ? detailsData[0]?.['Sku Group 2'] : ''} />
                            <div></div>
                            <InfoField title="Active: " value={detailsData ? detailsData[0]?.['Active'] : ''} />
                            <div></div>
                            <InfoField title="Sku Group 3: " value={detailsData ? detailsData[0]?.['Sku Group 3'] : ''} />
                            <div></div>
                            <InfoField title="Lot Control: " value={detailsData ? detailsData[0]?.['Lot Control'] : ''} />
                            <div></div>
                            <InfoField title="Serical Control: " value={detailsData ? detailsData[0]?.['Serical Control'] : ''} />
                            <div></div>
                            <InfoField title="Price: " value={detailsData ? detailsData[0]?.['Price'] : ''} />
                            <div></div>
                            <InfoField title="Dangerous Goods: " value={detailsData ? detailsData[0]?.['Dangerous Goods'] : ''} />
                            <div></div>
                            <InfoField title="Kit Item: " value={detailsData ? detailsData[0]?.['Kit Item'] : ''} />
                            <div></div>
                            <InfoField title="Peice Scan: " value={detailsData ? detailsData[0]?.['Peice Scan'] : ''} />
                            <div></div>
                            <InfoField title="Description: " value={detailsData ? detailsData[0]?.['Description'] : ''} />
                        </div>
                    </div>
                </div>
                <div className="w-full p-4 bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    <Tabs.Group version={1}>
                        <Tabs.List>
                            {/* <Tabs>Details</Tabs> */}
                            <Tabs>SOH</Tabs>
                            <Tabs>Multi UOM</Tabs>
                            <Tabs>BOM</Tabs>
                        </Tabs.List>
                        <Tabs.Panels className="mt-4">
                            {/* <Tabs.Panel>
                                <div className="grid grid-cols-1 gap-x-4 gap-y-4">
                                    <SimpleTable>
                                        <thead>
                                            <SimpleTable.TR>
                                                <SimpleTable.TH>Product Code</SimpleTable.TH>
                                                <SimpleTable.TH>Lot Control</SimpleTable.TH>
                                                <SimpleTable.TH>Weight (Kg)</SimpleTable.TH>
                                                <SimpleTable.TH>Description</SimpleTable.TH>
                                            </SimpleTable.TR>
                                        </thead>
                                        <tbody>
                                            {(detailsData ?? []).map((item, index) => (
                                                <SimpleTable.TR
                                                    key={`details-${index}`}
                                                    onClick={() => {
                                                        setData(item)
                                                        setOpen(true)
                                                    }}
                                                >
                                                    <SimpleTable.TD>{item?.['Product Code']}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.['Lot Control']}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.['Weight (KG)']}</SimpleTable.TD>
                                                    <SimpleTable.TD className="text-left">{item?.['Description']}</SimpleTable.TD>
                                                </SimpleTable.TR>
                                            ))}
                                        </tbody>
                                    </SimpleTable>
                                </div>
                            </Tabs.Panel> */}
                            <Tabs.Panel>
                                <div className="grid grid-cols-1 gap-x-4 gap-y-4">
                                    <SimpleTable>
                                        <thead>
                                            <SimpleTable.TR>
                                                <SimpleTable.TH>Whse</SimpleTable.TH>
                                                <SimpleTable.TH>Customer</SimpleTable.TH>
                                                <SimpleTable.TH>SKU</SimpleTable.TH>
                                                <SimpleTable.TH>Description</SimpleTable.TH>
                                                <SimpleTable.TH>Available Quantity</SimpleTable.TH>
                                                <SimpleTable.TH>SOH</SimpleTable.TH>
                                                <SimpleTable.TH>Quantity Hold</SimpleTable.TH>
                                                <SimpleTable.TH>Manufacture Date</SimpleTable.TH>
                                                <SimpleTable.TH>Expiry Date</SimpleTable.TH>
                                                <SimpleTable.TH>Batch No.</SimpleTable.TH>
                                                <SimpleTable.TH>Serial</SimpleTable.TH>
                                            </SimpleTable.TR>
                                        </thead>
                                        <tbody>
                                            {(itemData ?? []).map((item, index) => (
                                                <SimpleTable.TR
                                                    key={`item-${index}`}
                                                    onClick={() => {
                                                        setData(item)
                                                        setOpenSOH(true)
                                                    }}
                                                >
                                                    <SimpleTable.TD>{item?.whse}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.customer}</SimpleTable.TD>
                                                    <SimpleTable.TD className="text-left">{item?.sku}</SimpleTable.TD>
                                                    <SimpleTable.TD className="text-left">{item?.description}</SimpleTable.TD>
                                                    <SimpleTable.TD className="text-left">{item?.available}</SimpleTable.TD>
                                                    <SimpleTable.TD className="text-left">{item?.soh}</SimpleTable.TD>
                                                    <SimpleTable.TD className="text-left">{item?.qty_hld}</SimpleTable.TD>
                                                    <SimpleTable.TD className="text-left">{item?.man_date}</SimpleTable.TD>
                                                    <SimpleTable.TD className="text-left">{item?.exp_date}</SimpleTable.TD>
                                                    <SimpleTable.TD className="text-left">{item?.batch_num}</SimpleTable.TD>
                                                    <SimpleTable.TD className="text-left">{item?.serial}</SimpleTable.TD>
                                                </SimpleTable.TR>
                                            ))}
                                        </tbody>
                                    </SimpleTable>
                                </div>
                            </Tabs.Panel>
                            <Tabs.Panel>
                                <div className="grid grid-cols-1 gap-x-4 gap-y-4">
                                    <SimpleTable>
                                        <thead>
                                            <SimpleTable.TR>
                                                <SimpleTable.TH>Pack</SimpleTable.TH>
                                                <SimpleTable.TH>UOM</SimpleTable.TH>
                                                <SimpleTable.TH>Qty</SimpleTable.TH>
                                                <SimpleTable.TH>Description</SimpleTable.TH>
                                                <SimpleTable.TH>Cartonise</SimpleTable.TH>
                                                <SimpleTable.TH>Length (CM)</SimpleTable.TH>
                                                <SimpleTable.TH>Width (CM)</SimpleTable.TH>
                                                <SimpleTable.TH>Height (CM)</SimpleTable.TH>
                                                <SimpleTable.TH>Weight (KG)</SimpleTable.TH>
                                            </SimpleTable.TR>
                                        </thead>
                                        <tbody>
                                            {(packData ?? []).map((item, index) => (
                                                <SimpleTable.TR
                                                    key={`pack-${index}`}
                                                    onClick={() => {
                                                        setData(item)
                                                        setOpenUOM(true)
                                                    }}
                                                >
                                                    <SimpleTable.TD>{item?.Pack}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.UOM}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.Qty}</SimpleTable.TD>
                                                    <SimpleTable.TD className="text-left">{item?.Description}</SimpleTable.TD>
                                                    <SimpleTable.TD className="text-left">{item?.Cartonise}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.['Length (CM)']}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.['Width (CM)']}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.['Height (CM)']}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.['Weight (KG)']}</SimpleTable.TD>
                                                </SimpleTable.TR>
                                            ))}
                                        </tbody>
                                    </SimpleTable>
                                </div>
                            </Tabs.Panel>
                            <Tabs.Panel>
                                <div className="grid grid-cols-1 gap-x-4 gap-y-4">
                                    <SimpleTable>
                                        <thead>
                                            <SimpleTable.TR>
                                                <SimpleTable.TH>Product Code</SimpleTable.TH>
                                                <SimpleTable.TH>Description</SimpleTable.TH>
                                                <SimpleTable.TH>Amount</SimpleTable.TH>
                                            </SimpleTable.TR>
                                        </thead>
                                        <tbody>
                                            {(bomData ?? []).map((item, index) => (
                                                <SimpleTable.TR
                                                    key={`bom-${index}`}
                                                    onClick={() => {
                                                        setData(item)
                                                        setOpenBOM(true)
                                                    }}
                                                >
                                                    <SimpleTable.TD>{item?.['Product Code']}</SimpleTable.TD>
                                                    <SimpleTable.TD className="text-left">{item?.Description}</SimpleTable.TD>
                                                    <SimpleTable.TD>{item?.Amount}</SimpleTable.TD>
                                                </SimpleTable.TR>
                                            ))}
                                        </tbody>
                                    </SimpleTable>
                                </div>
                            </Tabs.Panel>
                        </Tabs.Panels>
                    </Tabs.Group>
                </div>

                <Modal
                    show={open}
                    onClose={() => {
                        setOpen(false)
                    }}
                >
                    <div className="flex flex-col gap-1 m-3">
                        <h2 className="font-semibold text-black text-title-md">{'Details'}</h2>
                    </div>
                    <div className="flex flex-col items-center">
                        <div className="w-full bg-white border rounded-sm overflow-auto max-h-150 border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                            <div className="flex flex-col gap-3 py-6 px-8">
                                <div className="grid grid-cols-1 gap-4">
                                    <InfoField grid={false} title="Product Code: " value={data?.['Product Code']} />
                                    <InfoField grid={false} title="Length (CM): " value={data?.['Length (CM)']} />
                                    <InfoField grid={false} title="Width (CM): " value={data?.['Width (CM)']} />
                                    <InfoField grid={false} title="Height (CM): " value={data?.['Height (CM)']} />
                                    <InfoField grid={false} title="Weight (KG): " value={data?.['Weight (KG)']} />
                                    <InfoField grid={false} title="Barcode 1: " value={data?.['Barcode 1']} />
                                    <InfoField grid={false} title="Barcode 2: " value={data?.['Barcode 2']} />
                                    <InfoField grid={false} title="Barcode 3: " value={data?.['Barcode 3']} />
                                    <InfoField grid={false} title="Sku Group 1: " value={data?.['Sku Group 1']} />
                                    <InfoField grid={false} title="Sku Group 2: " value={data?.['Sku Group 2']} />
                                    <InfoField grid={false} title="Sku Group 3: " value={data?.['Sku Group 3']} />
                                    <InfoField grid={false} title="Lot Control: " value={data?.['Lot Control']} />
                                    <InfoField grid={false} title="Price: " value={data?.Price} />
                                    <InfoField grid={false} title="Description: " value={data?.Description} />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal
                    show={openSOH}
                    onClose={() => {
                        setOpenSOH(false)
                    }}
                >
                    <div className="flex flex-col gap-1 m-3">
                        <h2 className="font-semibold text-black text-title-md">{'SOH'}</h2>
                    </div>
                    <div className="flex flex-col items-center">
                        <div className="w-full bg-white border rounded-sm overflow-auto max-h-150 border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                            <div className="flex flex-col gap-3 py-6 px-8">
                                <div className="grid grid-cols-1 gap-4">
                                    <InfoField grid={false} title="Wharehouse: " value={data?.whse} />
                                    <InfoField grid={false} title="Customer: " value={data?.customer} />
                                    <InfoField grid={false} title="Product: " value={data?.sku} />
                                    <InfoField grid={false} title="Available Quantity: " value={data?.available} />
                                    <InfoField grid={false} title="SOH: " value={data?.soh} />
                                    <InfoField grid={false} title="Allocated Quantity: " value={data?.qty_alloc} />
                                    <InfoField grid={false} title="Hold Quantity: " value={data?.qty_hld} />
                                    <InfoField grid={false} title="Manufacture Date: " value={data?.man_date} />
                                    <InfoField grid={false} title="Expiry Date: " value={data?.exp_date} />
                                    <InfoField grid={false} title="Description: " value={data?.description} />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal
                    show={openUOM}
                    onClose={() => {
                        setOpenUOM(false)
                    }}
                >
                    <div className="flex flex-col gap-1 m-3">
                        <h2 className="font-semibold text-black text-title-md">{'Multi UOM'}</h2>
                    </div>
                    <div className="flex flex-col items-center">
                        <div className="w-full bg-white border rounded-sm overflow-auto max-h-150 border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                            <div className="flex flex-col gap-3 py-6 px-8">
                                <div className="grid grid-cols-1 gap-4">
                                    <InfoField grid={false} title="Pack: " value={data?.Pack} />
                                    <InfoField grid={false} title="UOM: " value={data?.UOM} />
                                    <InfoField grid={false} title="Quantity: " value={data?.Qty} />
                                    <InfoField grid={false} title="Cartonise: " value={data?.Cartonise} />
                                    <InfoField grid={false} title="Length (CM): " value={data?.['Length (CM)']} />
                                    <InfoField grid={false} title="Width (CM): " value={data?.['Width (CM)']} />
                                    <InfoField grid={false} title="Height (CM): " value={data?.['Height (CM)']} />
                                    <InfoField grid={false} title="Weight (KG): " value={data?.['Weight (KG)']} />
                                    <InfoField grid={false} title="Description: " value={data?.Description} />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal
                    show={openBOM}
                    onClose={() => {
                        setOpenBOM(false)
                    }}
                >
                    <div className="flex flex-col gap-1 m-3">
                        <h2 className="font-semibold text-black text-title-md">{'BOM'}</h2>
                    </div>
                    <div className="flex flex-col items-center">
                        <div className="w-full bg-white border rounded-sm overflow-auto max-h-150 border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                            <div className="flex flex-col gap-3 py-6 px-8">
                                <div className="grid grid-cols-1 gap-4">
                                    <InfoField grid={false} title="Product Code: " value={data?.['Product Code']} />
                                    <InfoField grid={false} title="Amount: " value={data?.Amount} />
                                    <InfoField grid={false} title="Description: " value={data?.Description} />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        </>
    )
}

export default View
